import React from 'react';
import cx from 'classnames';
import Paragraph from './paragraph';
import Title from './title';
// @ts-ignore
export const CnSkeleton = (props) => {
    const { className, ...others } = props;
    return (React.createElement("div", { className: cx(className, 'cn-ui-m-skeleton'), ...others }, props.children));
};
CnSkeleton.Title = Title;
CnSkeleton.Paragraph = Paragraph;
